import { Component } from '@angular/core';

@Component({
    selector: 'nstab',
    templateUrl: './nstab.component.html',
    styleUrl: './nstab.component.scss',
    standalone: false
})
export class NstabComponent {

}
